<template>
  <div class="page">
    <div class="page-single d-flex align-items-center justify-content-center" style="min-height: 100vh">
      <div class="container">
        <div class="col col-login mx-auto">
          <div class="text-center"></div>
          <form @submit.prevent="doLogin" class="card">
            <div class="flex text-center justify-content-center">
              <img src="@/assets/images/venteny.jpg" class="mt-3" width="150" alt="" />
            </div>

            <div class="flex items-center justify-center bg-gray-50">
              <div class="w-full max-w-md">
                <div class="card-body px-6 text-left">
                  <div class="card-title">Login to your account</div>
                  <div v-if="err_show" class="alert alert-danger" role="alert">
                    <font-awesome-icon icon="exclamation-triangle" class="text-danger" />
                    <i class="fe fe-alert-triangle mr-2" aria-hidden="true"></i> {{ err_msg }}
                  </div>
                  <div class="form-group">
                    <label class="form-label">Email address</label>
                    <input
                      autocomplete="off"
                      v-model="v$.form.email.$model"
                      type="email"
                      class="form-control"
                      placeholder="Enter email"
                    />
                    <span class="text-red-500 text-xs" v-if="v$.form.email.$dirty && v$.form.email.required.$invalid"
                      >{{ $t("form.email") }} {{ $t("invalid.required_message") }}</span
                    >
                    <span class="text-red-500 text-xs" v-if="v$.form.email.$dirty && v$.form.email.email.$invalid"
                      >{{ $t("form.email") }} {{ $t("invalid.email_message") }}</span
                    >
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Password
                    </label>
                    <div style="position: relative; display: flex; align-items: center;">
                    <input
                      autocomplete="one-time-code"
                      v-model="v$.form.password.$model"
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control"
                      placeholder="Password"
                      style="padding-right: 45px; width: 100%;"
                    />
                      <span 
                        @click="togglePasswordVisibility"
                        style="position: absolute; right: 15px; cursor: pointer; display: flex; align-items: center; justify-content: center;"
                      >
                        <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                      </span>
                    </div>
                  </div>
                  <div class="form-group" v-if="isProd">
                    <vue-hcaptcha ref="captcha" @verify="verifyCaptcha" :sitekey="sitekey"></vue-hcaptcha>
                    <span class="text-red-500 text-xs" v-if="v$.form.token.$dirty && v$.form.token.required.$invalid"
                      >Please prove you are human!</span
                    >
                  </div>
                  <div class="form-footer">
                    <el-button @click="doLogin" type="primary" class="btn-primary btn-block" :loading="isLoading"
                      >Sign in</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import { LOGIN } from "@/store/modules/auth";
import base64RSA from "@/library/rsa-encrypt";

export default {
  name: "Login",
  metaInfo: {
    title: "Login",
  },
  components: {
    VueHcaptcha,
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      showPassword: false,
      form: {
        email: "",
        password: "",
        token: "",
      },
      sitekey: process.env.VUE_APP_HCAPTCHA_SITE_KEY,
      err_msg: this.$t("response_error.general_error"),
      err_show: false,
      isLoading: false,
      isProd: process.env.NODE_ENV !== "development",
    };
  },
  mounted() {},
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    async doLogin() {
      this.v$.form.$touch();
      if (this.v$.form.$error) return;

      this.isLoading = true;
      this.err_show = false;

      try {
        const dataForm = {
          email: this.form.email,
          password: base64RSA.encrypt(this.form.password).toString("base64"),
          token: this.form.token,
        };
        await this.$store.dispatch(LOGIN, dataForm);
        this.$router.push({ name: "Dashboard" });
      } catch (err) {
        const key = `response_error.${err.response?.data?.error?.title}`;
        this.err_msg = this.$te(key) ? this.$t(key) : err.response?.data?.error?.message;
        this.err_show = true;
        this.$refs.captcha?.reset();
      } finally {
        this.isLoading = false;
      }
    },
    verifyCaptcha(token) {
      this.form.token = token;
    },
  },
  validations() {
    return {
      form: {
        email: {
          required,
          email,
        },
        password: {
          required,
        },
        token: {
          required: this.isProd ? required : () => true,
        },
      },
    };
  },
};
</script>
<style>
.page-single {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #f5f5f5; */
}

.card {
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  border: none;
}
</style>
